define(['text!./templates/pa-quick-quote-quote-error-state.html'], (template) =>[() => ({
    'restrict': 'A',
    template
})]);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/quote/directives/PAQuickQuoteQuoteErrorState.js
 **/